<template>

    <div class="footer">

        <div>
            <img id="about" alt="Yoga By Ian" src="../../assets/logo/ybi-logo-footer.png">
        </div>

        <div class="footer-txt">
            <b>YogaByIan.co.uk is (C) Copyright 2026, including all site assets, logos, photos, music and video.  Music composed, performed and recorded by Ian.  All rights reserved.</b>
            <p>This site uses only essential cookies. The site does not use nor store personal data. [Site revision: Palolem 0.2.2]</p>  
        </div>

    </div>

</template>

<script>
    export default {
        name: 'AppFooter'
    }
</script>

<style>
    .footer {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content:left;
        margin-top: 30px;
        padding-left: 0px;

        background-color: rgb(231, 252, 212);
      
    }

    .footer img {
        height: 60px;
        padding-top: 10px;
    }

    .footer-txt {
        width: 1000px;
        padding-top: 20px;
        padding-left: 10px;
        font-size: 12px;
        text-align: left;
    }

</style>
